<template>
  <tr :class="{ 'boss-table-4-selected': isCurrentPhase }">
    <td data-test="phase-name">
      <div class="pega-md-radio">
        <input
          :id="`phase-${selection.phase.id}`"
          :value="selection.phase.id"
          :checked="isCurrentPhase"
          type="radio"
          @change="updateSelectionPhase($event.target._value)"
        >
        <label
          :for="`phase-${selection.phase.id}`"
          class="pega-input"
        >{{
          phaseName
        }}</label>
      </div>
    </td>
    <td data-test="status">
      <select
        v-model="statusId"
        data-test="select-statuses"
        class="boss-input-select"
        @change="updateStatus"
      >
        <option :value="null">
          −
        </option>
        <option
          v-for="(status, j) in allStatuses"
          :key="j"
          :data-test="'status-' + j"
          :value="status.id"
        >
          {{ status.name }}
        </option>
      </select>
    </td>
    <td
      v-if="selection.isEntryPhase"
      data-test="start-date-label"
    >
      {{ startDate | dateLabel }}
    </td>
    <td
      v-else
      class="pega-picker-td pega-min-width-35-vw"
    >
      <date-picker
        v-model="date"
        :minute-step="10"
        type="date"
        input-class="pega-picker"
        :style="{ width: 'auto' }"
        placeholder="日付を選択"
        value-type="YYYY-MM-DDTHH:mm"
        :editable="false"
        @change="updateDateTime"
        @clear="clearDateTime"
      />
      <date-picker
        v-model="times"
        :minute-step="10"
        :disabled-time="notNightTime"
        :default-value="defaultValueInDaytime"
        type="time"
        popup-class="pega-custom-time-header"
        placeholder="時間を選択"
        range
        format="HH:mm"
        input-class="pega-picker"
        :popup-style="{ width: '300px' }"
        :style="{ width: 'auto' }"
        value-type="YYYY-MM-DDTHH:mm"
        :editable="false"
        @close="updateDateTime"
        @clear="clearTime"
      >
        <template #header>
          <div class="mx-range-wrapper mx-btn-text pega-time-header">
            <div class="mx-time">
              <div class="text-center">
                時：分
              </div>
            </div>
            <div class="mx-time">
              <div class="text-center">
                時：分
              </div>
            </div>
          </div>
        </template>
      </date-picker>
      <template v-if="selection.isEditRemind">
        <template v-if="isRemindSent">
          <label
            class="display-inline boss-annotation-text"
            data-test="remind-sent"
          >※送信済み</label>
        </template>
        <div v-if="isRemindSent && placeName !== null">
          <label
            class="display-inline boss-annotation-text"
            data-test="remind-sent-place"
          >面接場所：{{ placeName }}</label>
        </div>
        <template v-if="!isRemindSent">
          <div class="pega-mt-05">
            <label
              v-for="(remindStatus, i) in remindStatusesMaster"
              :key="i"
              class="pega-badge-radio pega-mr-5"
            >
              <input
                v-model="remindStatusId"
                :value="remindStatus.id"
                :data-test="`remind-${remindStatus.id}`"
                :disabled="isDisabled(remindStatus.id)"
                type="radio"
                @change="updateRemindStatus($event.target._value)"
              >
              <span
                class="pega-badge-radio-text pega-badge-radio-check-mark"
                :data-test="`remind-name-${remindStatus.id}`"
              >
                {{ remindStatus.name }}
              </span>
            </label>
          </div>
          <div v-if="isDisplayInterviewPlace">
            <span class="pega-interview-place-select">
              <select
                v-model="placeId"
                data-test="place"
                class="boss-input-select width-100"
                @change="updateInterviewPlace"
              >
                <option
                  :value="null"
                  data-test="empty-place"
                >
                  面接場所を選択してください
                </option>
                <option
                  v-for="(interviewPlace, i) in interviewPlaces"
                  :key="i"
                  :data-test="'place-option-' + i "
                  :value="interviewPlace.placeId"
                >
                  {{ interviewPlace.placeName }}
                </option>
              </select>
            </span>
            <entry-interview-place-modal class="pega-interview-place-select-button" />
          </div>
        </template>
      </template>
    </td>
    <td>
      <select
        v-model="evaluationId"
        data-test="select-evaluations"
        class="boss-input-select"
        @change="updateEvaluation"
      >
        <option :value="null">
          −
        </option>
        <option
          v-for="(evaluation, j) in evaluationMaster"
          :key="j"
          :data-test="'evaluation-' + j"
          :value="evaluation.id"
        >
          {{ evaluation.name }}
        </option>
      </select>
    </td>
    <td>
      <textarea
        v-model="evaluationComment"
        data-test="evaluation-comment"
        class="boss-textarea-in-table-2"
        @change="updateEvaluationComment"
      />
    </td>
  </tr>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import DatePicker from 'vue2-datepicker'
import SelectionEventBus from '@/lib/selectionEventBus'
import datePickerFunction from '@/lib/datePickerFunction.js'
import Indicator from '@/lib/indicator'
import EntryInterviewPlaceModal from '@/components/molecules/EntryInterviewPlaceModal'

export default {
  components: {
    DatePicker,
    EntryInterviewPlaceModal
  },
  filters: {
    dateLabel (date) {
      return dayjs(date).format('YYYY年MM月DD日 HH時mm分')
    }
  },
  mixins: [datePickerFunction],
  props: {
    entryId: {
      type: Number,
      required: true
    },
    selection: {
      type: Object,
      required: true
    },
    isWithdraw: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      date: this.selection.startDate,
      times: [this.selection.startDate, this.selection.endDate],
      selectionStateType: this.selection.selectionStateType,
      isEntryPhase: this.selection.isEntryPhase,
      phaseId: this.selection.phase.id,
      phaseName: this.selection.phase.name,
      statusId: _.get(this, 'selection.status.id', null),
      evaluationId: _.get(this, 'selection.evaluation.id', null),
      evaluationComment: this.selection.evaluationComment,
      remindStatusId: this.selection.remindStatus,
      placeId: _.get(this, 'selection.interviewPlace.id', null),
      placeName: _.get(this, 'selection.interviewPlace.name', null),
      log: {}
    }
  },
  computed: {
    ...mapGetters('settings', [
      'responsibles',
      'allStatuses',
      'fixedStatuses',
      'interviewPlaces'
    ]),
    ...mapGetters([
      'evaluationMaster',
      'remindStatusesMaster'
    ]),
    startDate () {
      return this.concatDateAndTime(this.date, this.times[0])
    },
    endDate () {
      return this.concatDateAndTime(this.date, this.times[1])
    },
    isCurrentPhase () {
      return this.selection.selectionStateType === 2
    },
    isDisabled: function () {
      return function (id) {
      // id=3(マイページ表示・リマインドメール送信)の時は、設定した選考日時が現在の日付の前日の場合非活性(選択した日付 < 現在日日付 + 2日)
      // リマインドステータスに関係なく、設定した選考日時当日の場合は非活性(選択した日付 < 現在日日付 + 1日)
      // 退会者の場合
        return (id === 3 && dayjs(this.date).isBefore(`${dayjs().add(2, 'days').format('YYYY-MM-DD')}`, 'days')) ||
        (dayjs(this.date).isBefore(`${dayjs().add(1, 'days').format('YYYY-MM-DD')}`, 'days')) || this.isWithdraw
      }
    },
    isRemindSent () {
      // 送信済み判定 バックエンドでリマインド送った情報を持っていないため、リマインドメールを送る設定かつ日時で判定
      // id=3(マイページ表示・リマインドメール送信)の時かつバッチ送信時刻以降
      return this.selection.remindStatus === 3 && dayjs().isAfter(`${dayjs(this.date).subtract(1, 'days').format('YYYY-MM-DD')} 09:30`, 'minute')
    },
    isDisplayInterviewPlace () {
      // id=3(マイページ表示・リマインドメール送信)且つリマインドメール送信日以前であること
      return this.selection.remindStatus === 3 && !this.isRemindSent
    }
  },
  watch: {
    selection: {
      handler (val) {
        this.$set(this, 'date', val.startDate)
        this.$set(this, 'times', [val.startDate, val.endDate])
        this.$set(this, 'selectionStateType', val.selectionStateType)
        this.$set(this, 'isEntryPhase', val.isEntryPhase)
        this.$set(this, 'phaseId', val.phase.id)
        this.$set(this, 'phaseName', val.phase.name)
        this.$set(this, 'statusId', _.get(val, 'status.id', null))
        this.$set(this, 'evaluationId', _.get(val, 'evaluation.id', null))
        this.$set(this, 'evaluationComment', val.evaluationComment)
        this.$set(this, 'remindStatusId', val.remindStatus)
        this.$set(this, 'placeId', _.get(val, 'interviewPlace.id', null))
        this.setLog()
      }
    }
  },
  created () {
    this.setLog()
  },
  methods: {
    setLog () {
      // 更新失敗用のログデータを保持
      this.$set(this.log, 'date', this.date)
      this.$set(this.log, 'times', this.times)
      this.$set(this.log, 'remindStatusId', this.remindStatusId)
    },
    restoreFromLog () {
      // ログから取り直す
      this.$set(this, 'date', this.log.date)
      this.$set(this, 'times', this.log.times)
      this.$set(this, 'remindStatusId', this.log.remindStatusId)
    },
    updateEvaluation () {
      this.$http.secured.put(`/entry/view/entries/${this.entryId}/phases/${this.phaseId}/evaluation`, this.evaluationId).then(response => {
        this.$toasted.global.success({ message: '評価を更新しました。' })
        SelectionEventBus.emitSelectionUpdate()
      })
    },
    updateEvaluationComment () {
      this.$http.secured.put(`/entry/view/entries/${this.entryId}/phases/${this.phaseId}/comment/v1`, { comment: this.evaluationComment }).then(response => {
        this.$toasted.global.success({ message: '評価コメントを更新しました。' })
      })
    },
    updateStatus () {
      this.$http.secured.put(`/entry/view/entries/${this.entryId}/phases/${this.phaseId}/status`, this.statusId).then(response => {
        this.$toasted.global.success(
          {
            message: `選考ステータスを更新しました。${_.includes(this.fixedStatuses.map(status => status.id), this.statusId)
              ? `<br>応募者一覧では、画面右上の「${this.getFixedStatusesName(this.statusId)}」ボタンをONにした場合のみ表示されます。`
              : ''}`
          }
        )
        SelectionEventBus.emitSelectionUpdate()
      })
    },
    updateDateTime () {
      if (this.startDate && this.endDate) {
        this.$http.secured.put(`/entry/view/entries/${this.entryId}/phases/${this.phaseId}/date`, {
          startDate: this.startDate,
          endDate: this.endDate
        }).then(response => {
          this.$toasted.global.success({ message: '日時を更新しました。' })
          SelectionEventBus.emitSelectionUpdate()
        })
      }
    },
    clearDateTime () {
      this.$dialog.confirm('削除しますか？')
      // はいを押下した時
        .then(() => {
          this.$set(this, 'date', null)
          this.$set(this, 'times', [null, null])
          this.$http.secured.put(`/entry/view/entries/${this.entryId}/phases/${this.phaseId}/date`, {
            startDate: null,
            endDate: null
          }).then(response => {
            this.$toasted.global.success({ message: '日時を削除しました。' })
            SelectionEventBus.emitSelectionUpdate()
          })
        })
        .catch(() => {
          this.restoreFromLog()
        })
    },
    clearTime () {
      this.$set(this, 'times', [null, null])
    },
    updateRemindStatus (id) {
      this.$set(this, 'remindStatusId', id)
      this.$http.secured.put(`/entry/view/entries/${this.entryId}/phases/${this.phaseId}/remind_status`, {
        remindDate: {
          startDate: this.startDate,
          endDate: this.endDate
        },
        remindStatus: id
      }).then(response => {
        this.$toasted.global.success({ message: 'リマインド設定を更新しました。' })
        SelectionEventBus.emitSelectionUpdate()
      }).catch(() => {
        this.restoreFromLog()
      })
    },
    concatDateAndTime (date, time) {
      const dayjsDate = dayjs(date)
      const dayjsTime = dayjs(time)
      if (dayjsDate.isValid() && dayjsTime.isValid()) {
        return `${dayjsDate.format('YYYY-MM-DD')}T${dayjsTime.format('HH:mm')}`
      } else {
        return null
      }
    },
    updateSelectionPhase (id) {
      Indicator.emitShow()
      this.$http.secured.put('/entry/view/entries/phases', { entryIds: [this.entryId], itemId: id })
        .then(response => {
          this.$toasted.global.success({ message: '選考フェーズを更新しました。' })
          SelectionEventBus.emitSelectionUpdate()
        }).finally(() => {
          Indicator.emitHide()
        })
    },
    getFixedStatusesName (statusId) {
      return this.fixedStatuses.find(status => _.isEqual(status.id, statusId)).name
    },
    updateInterviewPlace () {
      this.$http.secured.put(`/entry/view/entries/${this.entryId}/phases/${this.phaseId}/interview_place`, this.placeId).then(response => {
        this.$toasted.global.success({ message: '面接場所を更新しました。' })
      })
    }
  }
}
</script>
